import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InventoryService } from '../../../../services/inventory.service';
import { gridPageRequest } from '../../../../model/common/common.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { GetproductLookupComponent } from '../../../Lookup/getproduct-lookup/getproduct-lookup.component';
import { AdministratorService } from '../../../../services/administrator.service';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { UnitsOfMeasure, Warehouse } from '../../../../model/administration.model';
import _ from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import { bom } from '../../../../model/inventory.model';
import { BillOfMaterialLookupComponent } from '../../../Lookup/Bill-Of- Material-lookup/BillOfMaterial-lookup.component';
import { of, forkJoin, timer, Observable } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { Table } from 'primeng/table';
import { SalesService } from '../../../../services/sales.service';
import { SpecificationLookupComponent } from '../../../Lookup/specification-lookup/specification-lookup.component';
import { VendorLookupComponent } from '../../../Lookup/vendor-lookup/vendor-lookup.component';
import { VendorService } from '../../../../services/vendor.service';

@Component({
  selector: 'app-create-bom',
  standalone: true,
  imports: [SharedModule, CommonModule, AutoCompleteModule],
  providers: [DialogService, MessageService],
  templateUrl: './create-bom.component.html',
  styleUrl: './create-bom.component.scss'
})
export class CreateBOMComponent implements OnInit {
  @ViewChild('dt1') dt1: Table | undefined;
  searchKey = new FormControl('');
  isEditMode: any;
  submitted: boolean = false;
  loader: boolean = false;
  displayMaximizable: boolean | undefined;
  bomId: any
  tableData: any;
  refData: { bomId: any; } | undefined;
  displayBasic: boolean = false;
  warehouseDropdown: any[] = [];
  UOMDropdown: UnitsOfMeasure[] = [];
  filteruom: UnitsOfMeasure[] = [];
  filtewarehouse: Warehouse[] = [];
  menuOptions: any[] = [];
  lineItemData: any[] = [];
  savedData: any;
  selectedProduct: any[] = [];
  deleteProductIds: any[] = [];
  filterProductList: any[] = [];
  unitLabel: string = '';
  rawMaterialSearch = new FormControl('');
  filterRawMaterialList: any[] = [];
  first = 0;

  constructor(private messageService: MessageService, public dialogService: DialogService,
    public ref: DynamicDialogRef, private inventoryService: InventoryService, private salesService: SalesService,
    private administratorService: AdministratorService, private billofmaterialservice: InventoryService, private vendorService: VendorService,
    private route: Router, private router: ActivatedRoute, private confirmationService: ConfirmationService, private cdr: ChangeDetectorRef) { }

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 10,
    id: 0
  }

  billOfMaterialForm = new FormGroup({
    productId: new FormControl(),
    productCode: new FormControl('', Validators.required),
    warehouse: new FormControl(""),
    warehouseId: new FormControl(),
    warehouseCode: new FormControl('', Validators.required),
    boMType: new FormControl('', Validators.required),
    unitsOfMeasureId: new FormControl(),
    unitsOfMeasureCode: new FormControl('', Validators.required),
    quantityAvailable: new FormControl<number | null>({ value: null, disabled: true }),
    quantity: new FormControl<number | null>(null, [Validators.required, Validators.min(0.01)]),
    UnitOfMeasure: new FormControl(),
    comment: new FormControl(),
    IsActive: new FormControl(true),
    CreatedBy: new FormControl()
  })

  ngOnInit(): void {
    document.title = 'Create Bill Of Material';
    this.getUOM();
    this.billOfMaterialForm.controls.CreatedBy.setValue(localStorage.getItem('username'))
    this.getWarehouse(this.pageRequest)
    this.patchBillOfMaterial();
    this.inventoryService.getUnitByAppKey('unitNameLabel').subscribe((res: any) => {
      this.unitLabel = res?.data || 'Unit';
    });
  }

  loadQtyAvailable(): void {
    const code = (this.billOfMaterialForm.controls.productCode.value || '').split(' - ')[0].trim();
    const warehouseId = this.billOfMaterialForm.controls.warehouseId.value;
    const qtyControl = this.billOfMaterialForm.controls.quantityAvailable;

    if (!code) {
      qtyControl.setValue(null);
      return;
    }

    this.inventoryService.getInventoryStatus(code).subscribe({
      next: (res: any) => {
        if (!Array.isArray(res)) {
          qtyControl.setValue(0);
          return;
        }
        const rows = warehouseId ? res.filter((i: any) => i.warehouseId === warehouseId) : res;
        const qty = rows.reduce((sum: number, i: any) => sum + (i.quantityAvailable ?? 0), 0);
        qtyControl.setValue(qty);
      },
      error: () => qtyControl.setValue(0)
    });
  }

  getProduct() {
    this.ref = this.dialogService.open(GetproductLookupComponent, {
      header: 'Product List',
      width: '60%',
      data: { Material: 'FG1112' }
    });
    this.ref.onClose.subscribe((data: bom) => {
      if (data) {
        this.billOfMaterialForm.patchValue({
          productId: data.productId,
          productCode: `${data.productCode} - ${data.productName}`,
          unitsOfMeasureId: data.unitsofMeasureId,
          unitsOfMeasureCode: data.unitsOfMeasure
        })
      }
    });
    this.loadQtyAvailable();
    this.isEditMode = !true;
  }

  setProduct(data: any) {
    if (this) {
      const productDisplay = data.value.formattedCode;
      this.billOfMaterialForm.controls.productCode.setValue(productDisplay);
      const productId = data.value.productId;
      this.billOfMaterialForm.controls.productId.setValue(productId);
      const unitsofMeasureId = data.value.unitsofMeasureId;
      this.billOfMaterialForm.controls.unitsOfMeasureId.setValue(unitsofMeasureId);
      const unitsOfMeasureCode = data.value.unitsOfMeasure;
      this.billOfMaterialForm.controls.unitsOfMeasureCode.setValue(unitsOfMeasureCode);
      this.billOfMaterialForm.controls.unitsOfMeasureCode.setValue(unitsOfMeasureCode);
      this.loadQtyAvailable();
    }
  }

  createBOMlineitem(savedData: any) {
    if (savedData && typeof savedData === 'object') {
      this.lineItemData = [...this.lineItemData, savedData];   // new array so the paginator updates
    }

    const validRecords = this.lineItemData.filter(record => typeof record === 'object' && record != null);

    if (validRecords.length > 0 && this.bomId && !this.isEditMode) {
      validRecords.forEach(record => {
        delete record.product;
        record.bomId = this.bomId;
        record.CreatedBy = localStorage.getItem('username');
      });

      this.loader = true;
      this.billofmaterialservice.createBOMLineItem(validRecords).subscribe({
        next: () => {
          this.lineItemData = [];
          this.loader = false;
        },
        error: (error: any) => {
          console.error('Error creating BOM line items:', error);
          this.loader = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to create BOM line items.' });
        }
      });
    }
  }


  saveBOM(data: any, isEditMode: boolean) {
    this.submitted = true;
    const isValid = this.validateForm();
    if (!isValid) {
      return;
    }

    if (this.lineItemData.length < 1) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please Enter Raw Material Product.' });
      return;
    }

    if (isEditMode) {
      this.updateBOM(data);
    } else {
      this.createBOM(data);
    }
  }

  createBOM(data: any) {
    this.submitted = true;
    const isValid = this.validateForm();
    if (!isValid) { return; }
    this.loader = true;
    this.billofmaterialservice.createBOM(data).subscribe({
      next: (response: any) => {
        this.bomId = response;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'BillOfMaterial Created Successfully.' })
        setTimeout(() => {
          this.createBOMlineitem('')
          this.route.navigate(['/home/listBillofMaterial']);
        }, 1000);
        this.loader = false;
      },
      error: error => {
        console.log(error);
        this.loader = false;
      }
    })
  }

  patchBillOfMaterial() {
    this.router.queryParams.subscribe(params => {
      this.bomId = params['bomId'];
      this.isEditMode = !!this.bomId;
      if (this.isEditMode) {
        document.title = 'Update Bill Of Material';
        this.billofmaterialservice.getBomById(this.bomId).subscribe(
          (billOfMaterial: any) => {
            if (billOfMaterial) {
              this.billOfMaterialForm.patchValue({
                ...billOfMaterial,
                'warehouse': billOfMaterial['warehouseCode'],
                'UnitOfMeasure': billOfMaterial['unitsOfMeasureCode']
              });
              this.getLineItemBOM(this.bomId);
              this.loadQtyAvailable();

            }
          },
          (error: any) => {
            console.error('Error fetching billOfMaterial data:', error);
          }
        );
      }
    })

  }

  getLineItemBOM(data: any) {
    this.billofmaterialservice.getBomLineItem(data).subscribe({
      next: (data: any) => {
        // if (Array.isArray(data)) {
        //   data.forEach((item: any) => {
        //     item.product = item.productCode;
        // console.log(item.product.productName);

        //   });
        this.lineItemData = data;
        // }
      },
      error: error => {
        console.log(error);
      }
    });
  }



  updateBOM(data: any) {
    data.bomId = this.bomId;
    if (data) {
      this.loader = true;
      this.billofmaterialservice.updateBOM(data).subscribe({
        next: responseData => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'BillOfMaterial Updated Successfully.' });
          this.route.navigate(['/home/listBillofMaterial']);
          this.loader = false;
        },
        error: error => {
          console.error('Error updating BillOfMaterial:', error);
          this.loader = false;
        }
      });
    } else {
      this.createBOM(data);
    }
  }


  getWarehouse(query: gridPageRequest) {
    this.administratorService.getAllWarehouse(query).subscribe({
      next: (data: any) => {
        this.warehouseDropdown = data.warehouses;
      }
    });
  }

  warehouseSelected(event: any) {
    if (event && event.value) {
      const selectedWarehouse = event.value;
      const combinedValue = `${selectedWarehouse.warehouseCode} - ${selectedWarehouse.warehouseName}`;

      this.billOfMaterialForm.controls['warehouseCode'].setValue(combinedValue);
      this.billOfMaterialForm.controls['warehouseId'].setValue(selectedWarehouse.warehouseId);
      this.billOfMaterialForm.controls['warehouseId'].setValue(selectedWarehouse.warehouseId);
      this.loadQtyAvailable();
    }
  }


  onUnitOfMeasureSelect(event: any) {
    if (this) {
      this.billOfMaterialForm.controls.unitsOfMeasureCode.setValue(_.toString(event.value.unitsofMeasure));
      this.billOfMaterialForm.controls.unitsOfMeasureId.setValue(event.value.unitsofMeasureId);
    }
  }

  getUOM() {
    this.administratorService.getAllUnitsOfMeasure(this.pageRequest).subscribe({
      next: (data: any) => {
        this.UOMDropdown = data.unitsofMeasures;
      },
      error: error => {
      }
    });
  }

  filterUOM(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.UOMDropdown as any[]).length; i++) {
      let uom = (this.UOMDropdown as any[])[i];
      if (uom.unitsofMeasureCode.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(uom);
      }
    }
    this.filteruom = filtered;
  }

  filteWarehouse(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.warehouseDropdown as any[]).length; i++) {
      let warehouse = (this.warehouseDropdown as any[])[i];
      if (warehouse.warehouseCode.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(warehouse);
      }
    }
    this.filtewarehouse = filtered;
  }

  AddBOM(bomInput: any) {
    let bomId: number | null = null;
    let lineItemData: any = null;

    if (bomInput && typeof bomInput === 'object' && 'bomId' in bomInput) {
      bomId = bomInput.bomId;
      lineItemData = bomInput;
    } else if (typeof bomInput === 'number') {
      bomId = bomInput;
      lineItemData = this.selectedProduct[0];
    } else {
      lineItemData = this.selectedProduct[0];
    }

    this.ref = this.dialogService.open(BillOfMaterialLookupComponent, {
      width: '80%',
      header: 'Add Component',
      data: {
        bomId: bomId,
        lineItemData: lineItemData
      }
    });

    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        const existingIndex = this.lineItemData.findIndex(item =>
          item.productId === data.productId && item.bomLineItemId === data.bomLineItemId
        );

        this.lineItemData = [...this.lineItemData];

        if (existingIndex !== -1) {
          this.lineItemData[existingIndex] = { ...data };
        } else {
          const duplicateIndex = this.lineItemData.findIndex(item =>
            item.productId === data.productId && !item.bomLineItemId
          );
          if (duplicateIndex !== -1) {
            this.lineItemData[duplicateIndex] = { ...data };
          } else {
            data.lineItemNo = this.lineItemData.length + 1;
            this.createBOMlineitem(data);
          }
        }
      }
      this.selectedProduct = [];
    });
  }

  cancel() {
    this.route.navigate(['/home/listBillofMaterial'])
  }

  reset() {
    this.billOfMaterialForm.reset();
  }

  get formControls() {
    return this.billOfMaterialForm.controls;
  }

  validateForm() {
    let isValid = true;
    if (this.billOfMaterialForm.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill Required field' })
      isValid = false;
    }
    return isValid;
  }


  deleteLineItem() {
    this.confirmationService.confirm({
      header: 'Are you sure?',
      message: 'Please confirm to proceed.',
      accept: () => {
        if (this.selectedProduct.length === 0) {
          this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'No items selected to delete.' });
          return;
        }

        const selectedBomIds = this.selectedProduct
          .map(item => item.bomLineItemId)
          .filter(id => id);

        const selectedLineItemNos = this.selectedProduct
          .map(item => item.lineItemNo)
          .filter(no => no);

        if (this.isEditMode) {
          this.deleteProductIds.push(...selectedBomIds);
        }

        this.lineItemData = this.lineItemData.filter(item => {
          const isSelected =
            (item.bomLineItemId && selectedBomIds.includes(item.bomLineItemId)) ||
            (item.lineItemNo && selectedLineItemNos.includes(item.lineItemNo));

          return !isSelected;
        });

        this.selectedProduct = [];

        this.messageService.add({
          severity: 'success', summary: 'Success',
          detail: 'Bill Of Material Line Item Deleted Successfully.'
        });
      },
      reject: () => {
        this.selectedProduct = [];
      }
    });
  }

  update(BOMData: any) {
    this.submitted = true;

    if (!this.validateForm()) return;

    if (this.lineItemData.length < 1) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please Enter Raw Material Product.' });
      return;
    }

    if (!this.validateLineItems()) return;

    this.loader = true;

    const request: Observable<any>[] = [];


    if (this.deleteProductIds && this.deleteProductIds.length > 0) {
      request.push(
        this.inventoryService.deleteBillOfMaterialLineItem(this.deleteProductIds).pipe(
          catchError(error => {
            console.error('Delete BOM Line Item error:', error);
            return of(null);
          })
        )
      );
    }

    for (const product of this.lineItemData) {
      if (product.bomLineItemId !== undefined && product.bomLineItemId !== null) {
        product.UpdatedBy = localStorage.getItem('username');
        request.push(
          this.inventoryService.updateBilOfMaterialLineItem(product).pipe(
            catchError(error => {
              console.error('Update BOM Line Item error:', error);
              return of(null);
            })
          )
        );
      } else {
        const newProduct = {
          IsActive: true,
          UnitOfMeasure: product.UnitOfMeasure,
          compQuantity: product.compQuantity,
          comment: product.comment,
          bomId: _.toNumber(this.bomId),
          specification: product.specification,
          standardCost: product.standardCost,
          make: product.make,
          Mkfpartid: product.mkfpartid,
          productCode: product.productCode,
          productCost: product.productCost,
          productId: product.productId,
          unitsOfMeasureCode: product.unitsOfMeasureCode,
          unitsOfMeasureId: product.unitsOfMeasureId,
          productSize: product.productSize,
          vendorId: product.vendorId,
          vendorCode: product.vendorCode,
          vendorName: product.vendorName,
          CreatedBy: localStorage.getItem('username')
        };

        const clonedProduct = _.cloneDeep(newProduct);

        request.push(
          this.inventoryService.createBOMLineItem([clonedProduct]).pipe(
            catchError(error => {
              console.error('Create BOM Line Item error:', error);
              return of(null);
            })
          )
        );
      }
    }

    timer(0).pipe(
      switchMap(() => forkJoin(request))
    ).subscribe({
      next: () => {
        if (BOMData) {
          BOMData.bomId = this.bomId;
          BOMData.UpdatedBy = localStorage.getItem('username');

          this.billofmaterialservice.updateBOM(BOMData).subscribe({
            next: () => {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'BillOfMaterial Updated Successfully.' });
              this.loader = false;
              setTimeout(() => {
                this.route.navigate(['/home/listBillofMaterial']);
              }, 1000);
            },
            error: (error) => {
              console.error('Error updating BillOfMaterial:', error);
              this.loader = false;
            }
          });
        } else {
          this.loader = false;
        }
      },
      error: (error) => {
        console.error('Error in update requests:', error);
        this.loader = false;
      }
    });
  }


  searchProduct() {
    if (!this.searchKey.value || this.searchKey.value.trim() === '') {
      return;
    }

    this.billofmaterialservice.autoSearchBomline(this.searchKey.value).subscribe({
      next: (data: any[]) => {
        if (data && Array.isArray(data)) {

          const filteredData = data.filter(item => Number(item.bomId) === Number(this.bomId));

          this.lineItemData = filteredData;

          if (this.dt1) {
            this.dt1.first = 0;
          }

          this.searchKey.setValue('');
          this.cdr.detectChanges();
        }
      },
      error: (error: any) => {
        console.error("Error fetching search results:", error);
      }
    });
  }


  refreshData(): void {
    if (this.dt1) {
      this.dt1.first = 0;
      this.dt1.clear();
    }
    this.getLineItemBOM(this.bomId);
  }

  autosearchProduct(event: any) {
    this.salesService.autoSearchProduct(event.query).subscribe(
      (data: any[]) => {
        if (data) {
          this.filterProductList = data
            .filter(product => product.productType === 'FG1112')
            .map(product => ({
              ...product,
              formattedCode: `${product.productCode} - ${product.productName}`
            }));
        }
      },
      (error: any) => {
        console.error('Error fetching products:', error);
      }
    );
  }

  autosearchRawMaterial(event: any) {
    this.salesService.autoSearchProduct(event.query).subscribe({
      next: (data: any[]) => {
        if (data) {
          this.filterRawMaterialList = data
            .filter(product => product.productType === 'RM1113')
            .map(product => ({
              ...product,
              formattedCode: `${product.productCode} - ${product.productName}`
            }));
        }
      },
      error: (error: any) => console.error('Error fetching products:', error)
    });
  }

  showSpecification(row: any) {
    if (!row.productId) {
      this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Incomplete Product Data.' });
      return;
    }

    const ref = this.dialogService.open(SpecificationLookupComponent, {
      header: 'Raw Material Specification',
      width: '50%',
      data: {
        ...row,
        ProductId: row.productId,
        ProductSpecification: row.specification
      }
    });

    ref.onClose.subscribe((data: any) => {
      if (data) {
        row.specification = data.ProductSpecification ?? data.specification ?? row.specification;
        this.lineItemData = [...this.lineItemData];
      }
    });
  }

  addRawMaterial(event: any) {
    const p = event.value;
    if (!p) return;

    if (this.lineItemData.some(x => x.productId === p.productId)) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Product already added.' });
      this.rawMaterialSearch.setValue('');
      return;
    }

    const nextNo = Math.max(0, ...this.lineItemData.map(x => +x.lineItemNo || 0)) + 1;

    const row: any = {
      product: p.productName,
      productId: p.productId,
      productCode: p.formattedCode,
      productSize: p.productSize,
      specification: p.productSpecification,
      make: p.make,
      mkfpartid: p.mkfpartid,
      comment: p.productcomment,
      unitsOfMeasureId: p.unitsofMeasureId,
      unitsOfMeasureCode: _.toString(p.unitsOfMeasure),
      UnitOfMeasure: _.toString(p.unitsOfMeasure),
      compQuantity: 1,
      standardCost: p.standardCost ?? null,
      lineItemNo: nextNo,
      vendorId: p.vendorId ?? p.vendor?.vendorId ?? null,
      vendorCode: p.vendorCode ?? p.vendor?.vendorCode ?? '',
      vendorName: p.vendorName ?? p.vendor?.vendorName ?? '',
      IsActive: true,
      createdBy: localStorage.getItem('username')
    };

    if (row.vendorId && !row.vendorName) {
      this.vendorService.getVendorById(row.vendorId).subscribe({
        next: (v: any) => {
          row.vendorCode = v?.vendorCode;
          row.vendorName = v?.vendorName;
          this.lineItemData = [...this.lineItemData];
        }
      });
    }

    this.lineItemData = [...this.lineItemData, row];
    this.rawMaterialSearch.setValue('');

    const rows = 10;
    this.first = Math.floor((this.lineItemData.length - 1) / rows) * rows;
    setTimeout(() => document.getElementById('rmCodeInput')?.focus());
  }

  onRowUomChange(row: any, event: any) {
    const u = this.UOMDropdown.find((x: any) => x.unitsofMeasureId === event.value);
    row.unitsOfMeasureId = event.value;
    row.unitsOfMeasureCode = u?.unitsofMeasure;
    row.UnitOfMeasure = u?.unitsofMeasure;
  }

  removeRawMaterial(row: any) {
    this.selectedProduct = [row];
    this.deleteLineItem();
  }

  validateLineItems(): boolean {
    const bad = this.lineItemData.find(r =>
      r && typeof r === 'object' &&
      (!(+r.compQuantity > 0) || !r.unitsOfMeasureCode || !r.standardCost));

    if (bad) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: `Quantity, UOM and Product Price are required for ${bad.productCode?.split(' - ')[0] ?? 'each product'}.`
      });
      return false;
    }
    return true;
  }


  onKeyDownQty(event: KeyboardEvent): void {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', '.', 'Delete'];
    if (!allowedKeys.includes(event.key) && !/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  }

  openVendorLookup(row: any) {
    const ref = this.dialogService.open(VendorLookupComponent, {
      header: 'Vendor List',
      width: '60%'
    });

    ref.onClose.subscribe((v: any) => {
      if (v) {
        row.vendorId = v.vendorId;
        row.vendorCode = v.vendorCode;
        row.vendorName = v.vendorName;
        this.lineItemData = [...this.lineItemData];
      }
    });
  }

  clearVendor(row: any) {
    row.vendorId = null;
    row.vendorCode = '';
    row.vendorName = '';
    this.lineItemData = [...this.lineItemData];
  }

}

